import { IApplicationContext } from '../../../shared/types/applicationContext';
import { TApplicationState } from '../../../shared/types/redux';
import { createReduxStore } from '../../../shared/utils/redux';

export function createApplicationState(context: IApplicationContext) {
  const { config } = context;

  const initialState = config.getStrict<TApplicationState>('initialState');

  return createReduxStore(initialState, context, true);
}
